import Register from '../views/leads/Register';
import SignUp from '../views/auth/SignUp';
import Login from '../views/auth/Login';
import Recover from '../views/auth/Recover';
import Activate from '../views/auth/Activate';
import NotFound from '../views/NotFound';

export default [
    {
        // 'id' is the optional property Web ID
        path: '/register/:id?',
        name: 'register',
        component: Register,
        meta: {
            title: 'Register',
        },
    },
    {
        path: '/sign-up',
        name: 'sign-up',
        component: SignUp,
        meta: {
            title: 'Sign Up',
        },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            title: 'Login',
        },
    },
    {
        path: '/recover',
        name: 'recover',
        component: Recover,
        meta: {
            title: 'Reset your password',
        },
    },
    {
        path: '/activate/:token',
        name: 'activate',
        component: Activate,
        meta: {
            title: 'Activate account',
        },
    },
    {
        path: '/404',
        name: '404',
        component: NotFound,
        meta: {
            title: '404',
        },
    },
];
